import { useEffect, useState } from 'react';

const IpRestrictionChecker: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isIpAllowed, setIsIpAllowed] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const currentPath = window.location.pathname;
    
    // /form を含むパスはIP制限をスキップ
    if (currentPath.includes('/form')) {
      console.log('IpRestrictionChecker: Skipping IP check for /form path:', currentPath);
      setIsIpAllowed(true);
      setIsLoading(false);
      return;
    }

    const checkIpRestriction = async () => {
      try {
        const apiUrl = `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api/ip-check`;
        console.log('IpRestrictionChecker: Checking IP restriction at:', apiUrl);
        
        const response = await fetch(apiUrl, {
          method: 'GET',
          credentials: 'include'
        });

        console.log('IpRestrictionChecker: Response status:', response.status);

        if (response.status === 403) {
          console.log('IpRestrictionChecker: IP access denied (403)');
          setIsIpAllowed(false);
        } else if (response.ok) {
          console.log('IpRestrictionChecker: IP access allowed (200)');
          setIsIpAllowed(true);
        } else {
          console.log('IpRestrictionChecker: Unexpected response status:', response.status);
          setIsIpAllowed(true);
        }
      } catch (error) {
        console.error('IpRestrictionChecker: IP restriction check failed:', error);
        setIsIpAllowed(true);
      } finally {
        setIsLoading(false);
      }
    };

    checkIpRestriction();
  }, []);

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  if (isIpAllowed === false) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
        padding: '20px'
      }}>
        <h1 style={{ color: '#dc3545', marginBottom: '20px' }}>403 Forbidden</h1>
        <p style={{ fontSize: '18px', marginBottom: '20px' }}>
          Access denied from this IP address.
        </p>
        <p style={{ color: '#6c757d' }}>
          Your IP address is not authorized to access this application.
        </p>
      </div>
    );
  }

  return <>{children}</>;
};

export default IpRestrictionChecker;